<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{$t("message.group.account.title.list")}}</h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <div>{{$t("message.group.account.desc.list.text0")}}</div>
        <div>{{$t("message.group.account.desc.list.text1")}}</div>
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-col cols="12" class="py-0">
        <div class="text-right ma-0 py-0 list-count">{{$t("message.group.account.desc.list.listCount1")}}：{{ view.accountList.length | addComma }}{{$t("message.group.account.desc.list.listCount2")}}</div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="view.accountList"
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          hide-default-footer
          mobile-breakpoint=0
          class="elevation-1"
          :page.sync="search.paging.page"
          :items-per-page="search.paging.itemsPerPage"
          @page-count="search.paging.pageCount = $event"
        >
          <template v-slot:item="{ item }">
            <tr :class="stopRowClass(item)">
              <td class="px-2">{{ item.mailAddress }}</td>
              <td class="px-2"><router-link :to="'/group/account/detail/' + item.accountId">{{ item.name }}</router-link></td>
              <td class="px-2">{{ item.busho }}</td>
              <td class="px-2">{{ item.telNo }}</td>
              <td class="px-2">{{ item.loginDt | dateFormatter }}</td>
              <td class="px-2" align="center">{{ item.groupAdminFlg === '1' ? '○' : ''}}</td>
              <td class="px-2" align="center">{{ item.tempStopFlg === '1' ? '○' : ''}}</td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination color="#0F9956" circle v-model="search.paging.page" :length="search.paging.pageCount"></v-pagination>
        </div>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import i18n from '@/message'
import GroupAccount from '@/api/group-account'

export default {
  name: 'GroupAccountList',
  data: () => ({
    view: {
      accountList: []
    },
    search: {
      paging: {
        page: 1,
        pageCount: 5,
        itemsPerPage: 50
      }
    }
  }),
  computed: {
    headers () {
      return [
        { text: i18n.t('message.group.account.label.list.mailAddress'), value: 'mailAddress', sortable: false },
        { text: i18n.t('message.group.account.label.list.name'), value: 'name', sortable: false, width: 200 },
        { text: i18n.t('message.group.account.label.list.busho'), value: 'busho', sortable: false, width: 150 },
        { text: i18n.t('message.group.account.label.list.telNo'), value: 'telNo', sortable: false, width: 150 },
        { text: i18n.t('message.group.account.label.list.loginDt'), value: 'loginDt', sortable: false, width: 150 },
        { text: i18n.t('message.group.account.label.list.groupAdminFlg'), align: 'center', value: 'groupAdminFlg', sortable: false, width: 80 },
        { text: i18n.t('message.group.account.label.list.tempStopFlg'), align: 'center', value: 'tempStopFlg', sortable: false, width: 105 }
      ]
    }
  },
  methods: {
    stopRowClass (item) {
      return (item.tempStopFlg === '1' ? '_stop' : '')
    },
    async goSearch () {
      this.view.accountList = await GroupAccount.search()
    }
  },
  created: function () {
    // 一覧の情報を取得
    this.goSearch()
  }
}
</script>

<style scoped>
  .v-data-table td {
    width: 50px;
  }
</style>

<style>
  ._stop {
    background-color: #c6c6c6;
  }
</style>
